import { render } from "./Q5Detaillee.vue?vue&type=template&id=0047484c"
import script from "./Q5Detaillee.vue?vue&type=script&lang=js"
export * from "./Q5Detaillee.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__